<div class="col-12 p-2 app-link">
  <a routerLink="/unified"> <mat-icon>home</mat-icon> Home </a>
</div>
<div class="col-12 p-2 app-link">
  <a routerLink="/case-explorer" class="" *hasPermission="'CaseExplorer'">
    <mat-icon>find_in_page</mat-icon> Case Explorer
  </a>
</div>
